/**
 * detailerQualificationsApi — AISC §1.7.0 §3.1 client.
 *
 * Backed by the new sfm-web-backend endpoints in routes/detailerQualifications.js.
 * All paths relative — ApiCall's baseURL = https://shopfloormgmt.com/api
 * already prefixes /api.
 */

import ApiCall from "./apicall";

export async function listDetailerQualifications(filters = {}) {
  const params = {};
  if (filters.user_id) params.user_id = filters.user_id;
  if (filters.status) params.status = filters.status;
  if (filters.qualification_type) params.qualification_type = filters.qualification_type;
  if (filters.expiring_within_days) params.expiring_within_days = filters.expiring_within_days;
  if (filters.limit) params.limit = filters.limit;

  const res = await ApiCall.get("/detailer-qualification", { params });
  // Response shape: { count, rows: [...] }
  return res.data;
}

export async function getDetailerQualification(id) {
  const res = await ApiCall.get(`/detailer-qualification/${id}`);
  return res.data;
}

export async function createDetailerQualification(payload) {
  const res = await ApiCall.post("/detailer-qualification", payload);
  return res.data;
}

export async function updateDetailerQualification(id, patch) {
  const res = await ApiCall.patch(`/detailer-qualification/${id}`, patch);
  return res.data;
}

export async function revokeDetailerQualification(id, revoke_reason) {
  const res = await ApiCall.post(`/detailer-qualification/${id}/revoke`, { revoke_reason });
  return res.data;
}

/**
 * Helper: derive an "is currently valid" flag for client-side display.
 * Mirrors the server-side DetailerQualification.prototype.isCurrentlyValid().
 */
export function isQualificationCurrentlyValid(q) {
  if (!q) return false;
  if (q.status !== "ACTIVE") return false;
  if (q.expiration_date && new Date(q.expiration_date) < new Date()) return false;
  return true;
}

/**
 * Helper: returns a string like "expires in 23 days" or "expired 5 days ago"
 * for badge display.
 */
export function expirationDescription(q) {
  if (!q || !q.expiration_date) return "non-expiring";
  const exp = new Date(q.expiration_date);
  const now = new Date();
  const days = Math.round((exp - now) / 86400000);
  if (days < 0) return `expired ${Math.abs(days)} days ago`;
  if (days === 0) return "expires today";
  if (days <= 30) return `expires in ${days} days`;
  return `expires ${exp.toISOString().slice(0, 10)}`;
}
